var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSavant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91634 11.3332C10.1571 11.3332 11.3337 10.2791 11.3337 9.18011C11.3337 8.1981 10.5119 7.61252 8.44846 7.20711C6.80515 6.88273 6.46896 6.48631 6.46896 6.01796C6.46896 5.47744 6.99188 5.07192 7.9069 5.07192C9.04605 5.07192 9.96107 5.55837 10.7173 6.49541H10.7733V5.79271C10.7733 5.60355 10.7362 5.51341 10.568 5.41428C9.84901 4.99987 8.99934 4.6665 7.86974 4.6665C5.92752 4.6665 4.76974 5.62153 4.76974 6.78371C4.76974 7.90981 5.81546 8.37827 7.86974 8.79268C9.17675 9.054 9.59692 9.43233 9.59692 9.99993C9.59692 10.5764 9.00865 10.9278 7.97225 10.9278C6.85186 10.9278 5.63804 10.4503 4.72302 9.27913H4.66699L4.75098 10.1621C4.76974 10.3512 4.82577 10.4413 4.96579 10.5225C5.82478 11.0179 6.81458 11.3332 7.91634 11.3332V11.3332Z",
    fill: "#696057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#696057"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavant);
export default __webpack_public_path__ + "static/media/savant.a23b787ce1ae36cd229d6707d2e32e09.svg";
export { ForwardRef as ReactComponent };